import type { ApyModes } from '@/types'

export const DEFAULT_PERIOD = 365
export const DEFAULT_EXCLUDE_REWARDS = false
export const DEFAULT_PROTOCOL_CURATED = false
export const DEFAULT_APY_MODE: ApyModes = '7day'
